import { render, staticRenderFns } from "./ProductItemWebForm.vue?vue&type=template&id=7ee7fe85&scoped=true&name=product-item-web-form&"
import script from "./ProductItemWebForm.vue?vue&type=script&lang=js&"
export * from "./ProductItemWebForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemWebForm.vue?vue&type=style&index=0&id=7ee7fe85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee7fe85",
  null
  
)

/* custom blocks */
import block0 from "./ProductItemWebForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports